import { render, staticRenderFns } from "./editSheet.vue?vue&type=template&id=2b85d38d&scoped=true"
import script from "./editSheet.vue?vue&type=script&lang=js"
export * from "./editSheet.vue?vue&type=script&lang=js"
import style0 from "./editSheet.vue?vue&type=style&index=0&id=2b85d38d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85d38d",
  null
  
)

export default component.exports